import { Component, computed, effect, ElementRef, inject, OnInit, viewChildren } from '@angular/core';
import { CardComponent } from './components/card/card.component';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { PlannerDayStateService } from '../../../../services/planner-day-state.service';
import { PlannerViewsStateService } from '../../../../services';
import { RouteTimelineService } from '../../services/route-timeline.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogService } from 'src/app/services/mat-dialog.service';
import { DialogComponent } from 'src/app/shared/dialogs/dialog/dialog.component';
import { StartPointComponent } from "../../../../shared/start-point/start-point.component";

@Component({
  selector: 'app-points',
  standalone: true,
  imports: [
    CardComponent,
    StartPointComponent
],
  templateUrl: './points.component.html',
  styleUrls: ['./points.component.scss'],
})
export class PointsComponent implements OnInit {
  public pointRef = viewChildren<ElementRef>('pointCard');
  
  private _customRouteService = inject(CustomRouteService);
  private _plannerDayStateService = inject(PlannerDayStateService);
  private _routeTimelineService = inject(RouteTimelineService);
  private _matDialogService = inject(MatDialogService);
  private _translateService = inject(TranslateService);
  private _plannerViewsStateService = inject(PlannerViewsStateService);
  
  private readonly _customRouteData = computed(() => this._customRouteService.customRouteData());
  get dailyCustomRouteData() {
    return this._customRouteData().dailyRoutes[this._dayToShowIndex()];
  }
  get dailyPoints() {
    return this.dailyCustomRouteData?.points;
  }
  
  private readonly _dayToShowIndex = computed(() => this._plannerDayStateService.dayToShowIndex());
  get dayToShowIndex() {
    return this._dayToShowIndex();
  }
    
  private readonly _now = computed(() => this._routeTimelineService.now());
  readonly pointStatuses = computed(() =>
    this.dailyPoints.map(point =>
      this._routeTimelineService.getCardStatusFromSegmentTime(point, this._now()))
  );
  
  public previousTitles: string[] = []; // TODO: CAMBIAR A OBJETO DE TRADUCCIONES
  
  ngOnInit(): void {
    if(this.dailyPoints.length === 0) {
      this._openNoPointsDialog();
    }
  }
  
  setPreviousTitles = effect(() => {
    if (this.dailyPoints) {
      this.previousTitles = this.dailyPoints.map((p, i) =>
        i === 0 ? this.dailyCustomRouteData.startPoint.address : this.dailyPoints[i - 1].title
      );
    }
  }, { allowSignalWrites: true });
  
  private _openNoPointsDialog(): void {
    const dialogRef = this._matDialogService.openMatDialog({
      component: DialogComponent,
      data: {
        iconName: 'alert',
        title: this._translateService.instant('No se encontraron recursos'),
        content: this._translateService.instant('Parece que según tus intereses se han configurado todos los recursos disponibles. Pulsa en “Editar ruta” y añade los recursos que más te interesen para tener una ruta completa.'),
        primaryActionButtonText: this._translateService.instant('Editar ruta'),
        secondaryActionButtonText: this._translateService.instant('Cancelar'),
        handleClickPrimaryButton: () => {
          this._plannerViewsStateService.isEditRouteView.set(true);
          dialogRef.close();
        },
        handleClickSecondaryButton: () => {
          dialogRef.close();
        }
      }
    })
  }
}
